import React, { useState } from 'react';
import { personalInfo } from '../data/mock';
import soundManager from '../utils/soundEffects';
import Sparkle from './Sparkle';
import ValorantModal from './ValorantModal';

const FindMeWidget = () => {
  const [valorantOpen, setValorantOpen] = useState(false);

  const socialLinks = [
    { icon: '💼', name: 'LinkedIn', url: personalInfo.linkedin },
    { icon: '📚', name: 'Goodreads', url: 'https://www.goodreads.com/user/show/154139047-sreeja-siri' }
  ];

  return (
    <>
      <div className="window">
        <div className="window-header text-xs">
          🔗 find me
        </div>
        <div className="window-body">
          <div className="space-y-1">
            {socialLinks.map((link, idx) => (
              <Sparkle key={idx} onInteract={() => soundManager.playClick()}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center py-1 px-2 bg-pink-100 hover:bg-pink-200 border border-pink-300 transition-colors text-xs"
                >
                  <span className="mr-1">{link.icon}</span>
                  {link.name}
                </a>
              </Sparkle>
            ))}
            <Sparkle onInteract={() => {
              soundManager.playClick();
              setValorantOpen(true);
            }}>
              <button
                onClick={() => setValorantOpen(true)}
                className="w-full text-center py-1 px-2 bg-pink-100 hover:bg-pink-200 border border-pink-300 transition-colors text-xs"
                style={{ color: '#0000ff', textDecoration: 'underline' }}
              >
                <span className="mr-1">🎮</span>
                Valorant
              </button>
            </Sparkle>
          </div>
        </div>
      </div>
      <ValorantModal isOpen={valorantOpen} onClose={() => setValorantOpen(false)} />
    </>
  );
};

export default FindMeWidget;
